import React, { FC, useEffect } from 'react'
import {
    FullPageGrid,
    ThemeProvider,
    THEMES,
} from '@epidemicsound/design-system'
import MessageProvider from 'providers/messageprovider'
import EnvironmentProvider from 'providers/environmentprovider'
import ActiveTrackProvider from 'providers/activetrackprovider'
import PlayerQueueProvider from 'providers/playerqueueprovider'
import LoadingProvider from 'providers/loadingprovider'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import styled from 'styled-components'
import { PortalLayout as Layout } from 'components/layout/portal/Layout'
import PageModeProvider from 'providers/pagemodeprovider'
import ContentfulPreviewProvider from 'providers/contentfulpreviewprovider'
import { smallScreenWidth } from 'hooks/hooks'
import { pageView } from 'utils/tracking'

const StyledCol = styled(FullPageGrid.Col)`
    margin-top: 8rem;
`

const StyledGrid = styled.div`
    .portal-page-grid {
        width: 100%;
    }

    @media only screen and (max-width: ${smallScreenWidth + 'px'}) {
        .portal-page-grid {
            padding-right: 0;
            padding-left: 0.5rem;
        }
    }
`

export const PortalLayout: FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    useEffect(() => {
        pageView('Portal')
    }, [])

    return (
        <ThemeProvider theme={THEMES.DARK}>
            <MessageProvider>
                <ContentfulPreviewProvider initialPreview={false}>
                    <EnvironmentProvider>
                        <ActiveTrackProvider>
                            <PlayerQueueProvider>
                                <LoadingProvider initialLoading={false}>
                                    <PageModeProvider initialMode={'View'}>
                                        <Layout>
                                            <StyledGrid>
                                                <FullPageGrid
                                                    className={
                                                        'portal-page-grid'
                                                    }
                                                >
                                                    <StyledCol size={12}>
                                                        <DndProvider
                                                            backend={
                                                                HTML5Backend
                                                            }
                                                        >
                                                            {children}
                                                        </DndProvider>
                                                    </StyledCol>
                                                </FullPageGrid>
                                            </StyledGrid>
                                        </Layout>
                                    </PageModeProvider>
                                </LoadingProvider>
                            </PlayerQueueProvider>
                        </ActiveTrackProvider>
                    </EnvironmentProvider>
                </ContentfulPreviewProvider>
            </MessageProvider>
        </ThemeProvider>
    )
}

export default PortalLayout
